import React, { useEffect } from "react";
import styles from "./imageToPixelArt.module.css";

const ImageToPixelArt = () => {
  useEffect(() => {
    document.title =
      "Image to Pixel Art - Converter Imagem em Pixel Art | Fohattech";
  }, []);

  return (
    <section className={styles.pageWrapper}>
      
      {/* LATERAL ADS */}
      <aside className={styles.ads}></aside>

      {/* CONTEÚDO CENTRAL */}
      <div className={styles.container}>
        
        {/* HEADER SEO */}
        <header className={styles.header}>
          <h1>Converter Imagem em Pixel Art</h1>
          <p>
            Transforme qualquer imagem em pixel art de forma rápida e gratuita.
            Ideal para jogos, arte digital e projetos criativos.
          </p>
        </header>

        {/* TOOL */}
        <div className={styles.toolBox}>
          <iframe
            src="/embed/image-to-pixel-art/index.html"
            title="Image to Pixel Art"
            loading="lazy"
          ></iframe>
        </div>

        {/* CONTEÚDO SEO */}
        <section className={styles.info}>
          <h2>O que é Pixel Art?</h2>
          <p>
            Pixel art é um estilo de arte digital onde as imagens são criadas
            com blocos visíveis de pixels. Muito utilizado em jogos retrô e
            projetos criativos, esse estilo continua popular até hoje.
          </p>

          <h3>O que você pode fazer com essa ferramenta:</h3>
          <ul>
            <li>✔ Converter fotos em pixel art</li>
            <li>✔ Criar sprites para jogos</li>
            <li>✔ Gerar arte retrô</li>
            <li>✔ Testar estilos visuais rapidamente</li>
          </ul>

          <h3>Para quem é indicado?</h3>
          <p>
            Perfeito para desenvolvedores de jogos, designers, artistas digitais
            e qualquer pessoa interessada em criar imagens no estilo pixelado.
          </p>
        </section>

      </div>

      {/* LATERAL ADS */}
      <aside className={styles.ads}></aside>

    </section>
  );
};

export default ImageToPixelArt;